import {ChangeDetectorRef, Component, ElementRef, EventEmitter, Pipe, PipeTransform, ViewChild, Inject} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import {
	L10nTranslatePipe,
	L10N_LOCALE, L10nLocale, L10N_CONFIG, L10nConfig, L10nTranslationService
} from 'angular-l10n';

import {HttpClient} from "@angular/common/http";
import {APIConfigService} from "../../api.config.service"; import {AngularMaterial2Module} from "../../app.module.material";
import {RestServiceImpl} from "../immerdrin/rest.service.impl";
import {RestService} from "../immerdrin/rest.service.interface";
import {AuthService} from "../../shared/auth.service";
import {SessionService} from "../../shared/session.service";
import {LoggerService} from "../../shared/logger.service";
import {oase_config} from "../../../environments/environment";
import {BreadcrumbService} from "../../shared/breadcrumb/breadcrumb.service";
import {OaseDeleteDialogComponent} from "../immerdrin/oase.delete.component";
import {Tabelle} from "../immerdrin/tabelle/tabelle";
import {FormControl} from "@angular/forms";
import {ReplaySubject} from "rxjs";
import {Subject} from "rxjs";
import {SelectFilterUtil} from "../immerdrin/select-filter.util";
import {FlexModule,MediaObserver} from "@ngbracket/ngx-layout";
import {LieferantenGruppe} from "../../shared/lieferantengruppe.model";
import {Frage} from "../fragebogen/frage.model";
import {AntwortInsertEditComponent} from "./antwort.insertEdit.component";
import {Antwort} from "../fragebogen/antwort.model";
import {Fragebogen} from "../fragebogen/fragebogen.model";

const PATH_FILE = 'app/protected/verwaltungantworten/verwaltungantworten.component.ts';
const OBJ_LNG_NAME = 'antwort';
const BACKEND_PATH_PREFIX = 'antwort';

@Component({
    selector: 'oase-verwaltungantworten',
    templateUrl: './verwaltungantworten.component.html',
    providers: [{ provide: RestService, useExisting: RestServiceImpl }],
    standalone:true, imports: [AngularMaterial2Module, L10nTranslatePipe, FlexModule]

})
export class VerwaltungantwortenComponent extends Tabelle<Antwort> {

	// rechte: Kernrecht[] = new Array<Kernrecht>();
	elternfragen: Frage[] = Array<Frage>(); //Mögliche abhängige Fragen
	elternantworten: Antwort[] = Array<Antwort>();

	typen: String[] = new Array<String>();
	// fragebogen: Fragebogen = this.sessService.getFragebogen();
	fragebogen: Fragebogen = null;
	frage: Frage = null;

	_selectsuche: string[] = new Array<string>();

	public filterCtl: FormControl = new FormControl();
	public selectCtl: FormControl = new FormControl();
	/** list of rechts filtered by search keyword */
	public filteredFragen: ReplaySubject<Frage[]> = new ReplaySubject<Frage[]>(1);
	maxSortierung: number = 1;

	/** Subject that emits when the component has been destroyed. */
	private _onDestroy = new Subject<void>();

	constructor(
		public route: ActivatedRoute,
		public router: Router,
		public breadcrumbService: BreadcrumbService,
		public snackBar: MatSnackBar,
		public authService: AuthService,
		public apiConfigService: APIConfigService, public http: HttpClient,
		@Inject(L10N_LOCALE) public locale: L10nLocale,
		@Inject(L10N_CONFIG) private config: L10nConfig,
		public translation: L10nTranslationService,
		public dialog: MatDialog,
		public media: MediaObserver,
		public changeDetectorRef: ChangeDetectorRef,
		public sessService: SessionService,
		public title: Title,
		public _logger: LoggerService) {

		super( route, router, breadcrumbService, snackBar,
			authService, http, translation, dialog, media, changeDetectorRef,
			sessService, title, _logger, apiConfigService, {
				OBJ_LNG_NAME: OBJ_LNG_NAME,
				BACKEND_PATH_PREFIX: BACKEND_PATH_PREFIX,
				ROUTE_NAME: "/verwaltungantworten",
				PATH_FILE: PATH_FILE,
				DEFAULT_SORT_COLUMN: "text",
				extraDataForAdding: { }
			}
		);

		this.fragebogen = this.sessService.getFragebogen();
		this.frage = this.sessService.getFrage();

		this.breadcrumbService.addFriendlyNameForRoute('/protected/verwaltungfragebogen/verwaltungfragen/verwaltungantworten', this.translation.translate('antwort.liste'));
		this.breadcrumbService.addFriendlyNameForRoute('/protected/verwaltungfragebogen/verwaltungfragen', this.translation.translate('frage.liste')+'('+this.frage.fragestellung+')');
		this.breadcrumbService.addFriendlyNameForRoute('/protected/verwaltungfragebogen', this.translation.translate('fragebogen.liste')+'('+this.fragebogen.name+')');

		this.displayedColumns = ['text', 'admin'];
		this.title.setTitle(this.getTitle());

	}

	getTitle() {
	    return this.translation.translate('antwort.title') + ' - ' + this.translation.translate('project.title');
	}

	extraInit() {
		super.extraInit();
	}

	public afterDataIsLoaded() {
	}

	createNewElement() {
		return new Antwort();
	}

	loeschenSpalteName() {
		return "text";
	}

	getApiParams() {
		if (this.frage == null) this.frage = this.sessService.getFrage();
		return "seite/"+this.frage.id;
	}

	vorHinzufuegen(element) {
		element.fragebogenId = this.fragebogen.id;
		element.frageId = this.frage.id;
		// element.typen = this.typen;
		// element.elternfragen = this.elternfragen;
		// element.maxSortierung = this.maxSortierung;
	}

	zeigeLoeschenMaske(element: any) {
		this._zeigeLoeschenMaske(element, OaseDeleteDialogComponent);
	}

	zeigeHinzufuegenMaske() {
		this._zeigeHinzufuegenMaske(AntwortInsertEditComponent);
	}

	zeigeBearbeitenMaske(element) {

		// this.getElternfragen(element);
		element.fragebogenId = this.fragebogen.id;
		element.frageId = this.frage.id;

		this._zeigeBearbeitenMaske(element, AntwortInsertEditComponent);
	}

}


// import { BreadcrumbService } from '../../shared/breadcrumb/breadcrumb.service';
// import { DateiArt } from '../datei/dateiart.model';
// import { DateiArtDetails } from '../datei/dateiartdetails.model';
// import { oase_config } from '../../../environments/environment';
// import { AuthService } from '../../shared/auth.service';
// import { Httpstatus } from '../../shared/response/httpstatus.model';
// import { Kernantwort } from '../../shared/response/kernantwort.model';
// import { SessionService } from '../../shared/session.service';
// import { Component, Pipe, PipeTransform, Inject, ViewChild } from '@angular/core';
// import { NgForm } from '@angular/forms';
// import { Response, ResponseType, RequestOptionsArgs, Headers } from '@angular/http';
// import { MatDialog, MatSnackBar } from '@angular/material';
// import { Title } from '@angular/platform-browser';
// import { ActivatedRoute, Router, ParamMap } from '@angular/router';
// import { Image } from 'angular-modal-gallery';
// import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
// import { DropzoneComponent } from 'ngx-dropzone-wrapper/dist';

// import { LoggerService } from '../../shared/logger.service';


// import { Md2DataTable, Md2Dialog } from 'md2';
// import { Observable } from 'rxjs/Rx';
// import { Fragebogen } from '../fragebogen/fragebogen.model';
// import { Frage } from '../fragebogen/frage.model';
// import { Antwort } from '../fragebogen/antwort.model';
// import {TableWith2Dialogs} from "../immerdrin/tablewith2dialogs";
//
//
// const PATH_FILE = 'app/protected/verwaltungantworten/verwaltungantworten.component.ts';
// const OBJ_LNG_NAME = 'antwort';
// const BACKEND_PATH_PREFIX = 'antwort/';
// const REST_API_BASE =
//   ( window.location.hostname == 'localhost' ? oase_config.restapi.schema + '://' : '' ) + // z.B. http://
//   ( window.location.hostname == 'localhost' ? oase_config.restapi.host : '' ) + // z.B. masterproject.oase.at
//   ( window.location.hostname == 'localhost' ? ( oase_config.restapi.port ? ':' + oase_config.restapi.port : '' ) : '' ) + '/' + // z.B. :80/ oder /
//   oase_config.restapi.path + '/'; // z.B. masterproject/
// const REST_API =
//   REST_API_BASE +
//   BACKEND_PATH_PREFIX; // z.B. kategorie/
// const REST_API_DATEI = REST_API_BASE + 'datei/';
//
// @Pipe({ name: 'dataPipeAntwort' })
// export class DataTablePipeAntwort implements PipeTransform {
//   constructor(private _logger: LoggerService) { }
//   transform(array: Antwort[], query: string): Antwort[] {
//     this._logger.log(PATH_FILE + ' - transform BEGIN');
//     this._logger.log(PATH_FILE + ' - transform array: ', array);
//     this._logger.log(PATH_FILE + ' - transform query: ', query);
//     if (query) {
//       return array.filter((value: Antwort, index: number, arr: Antwort[]) =>
//         value.text.toLowerCase().indexOf(query.toLowerCase()) > -1
//       );
//     }
//     return array;
//   } // transform
// } // class DataTablePipe
//
// @Component({
//   selector: 'oase-verwaltungantworten',
//   templateUrl: './verwaltungantworten.component.html',
//   styleUrls: ['./verwaltungantworten.component.css']
// })
// export class VerwaltungantwortenComponent extends TableWith2Dialogs {
//   OBJ_LNG_NAME = OBJ_LNG_NAME; // Wird benötigt das Konstanten nicht im Template refernziert werden können.
//   data: Antwort[] = Array<Antwort>();
//   typen: String[] = new Array<String>();
//   aktuell: Antwort = null;
//   frage: Frage = this.sessService.getFrage();
//   fragebogen: Fragebogen = this.sessService.getFragebogen();
//   neu: boolean = false;
//   search: string = '';
//   _selectsuche: string[] = new Array<string>();
//   dialogrunningajaxcall: boolean = false;
//   seconddialogrunningajaxcall: boolean = false;
//   ladedaten: boolean = true;
//   ladedatenAntworten: boolean = true;
//   maxSortierung: number = 1;
//   minDate: Date=new Date();
//   @ViewChild(Md2DataTable) md2datatable: Md2DataTable;
//   @ViewChild('insertedit') insertedit: Md2Dialog;
//   @ViewChild('delete') delete: Md2Dialog;
//
//   getTitle() {
//     return this.translation.translate('antwort.title') + ' - ' + this.translation.translate('project.title');
//   }
//
//   private getAntworten() {
//     this._logger.log(PATH_FILE + ' - getAntworten Begin');
//
//     this.ladedatenAntworten = true;
//     this.ladedaten = this.ladedatenAntworten;
//
//     // let myHeader = new Headers();
//     // myHeader.append('Cache-Control', 'no-cache, no-store, must-revalidate, max-age=0');
//
//     this.http
//       .get(this.REST_API + 'liste/'+this.frage.id)
//        // Um mehrfachaufrufe zu verhindern
//       .subscribe(
//       data => {
//         this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
//         this.data = data.json() as Antwort[];
//         if(this.data.length>0)
//           this.maxSortierung=this.data.length;
//         this._logger.log(PATH_FILE + ' - getAntworten End');
//         this.ladedatenAntworten = false;
//         this.ladedaten = this.ladedatenAntworten;
//         // Initial-Sortierung da dies über Attribute im HTML nicht korrekt funktioniert
//         if(this.md2datatable != null && (this.md2datatable.getSort() == null || this.md2datatable.getSort().sortBy == null || !this.md2datatable.getSort().sortBy))
//           this.md2datatable.setSort('sortierung', 'asc');
//         this.closeOpenDialog();
//       },
//       err => {
//         this.ladedatenAntworten = false;
//         this.ladedaten = this.ladedatenAntworten;
//         ErrorHelper.handleError(err,"Fehler beim holen der Antworten",this._logger, this.translation)
//       },
//       () => {
//         this.ladedatenAntworten = false;
//         this.ladedaten = this.ladedatenAntworten;
//         this._logger.log(PATH_FILE + ' - Holen der Antworten abgeschlossen')
//       }
//       );
//   } // getAntworten
//
//   speichern(antwort: Antwort, snacknachricht: string, reloadData: boolean = true) {
//     this._logger.debug(PATH_FILE + ' - speichern BEGIN');
//     this._logger.debug(PATH_FILE + ' - speichern - kategorie: ', JSON.stringify(antwort));
//     this._logger.debug(PATH_FILE + ' - speichern - this.aktuell: ', this.aktuell);
//     this._logger.debug(PATH_FILE + ' - speichern - reloadData: ', reloadData);
//
//     this.dialogrunningajaxcall = this.isDialogOpen() ? true : false;
//
//     let aktuell: Antwort = JSON.parse(JSON.stringify(this.aktuell));
//     this._logger.debug(PATH_FILE + ' - speichern - aktuell AFTER: ', aktuell);
//     this._logger.log(PATH_FILE + ' - speichern - http: ' + REST_API + (this.neu ? 'hinzufuegen/0' : 'bearbeiten/' + aktuell.id));
//
//     let request = null;
//     if(this.neu)
//       request = this.http.post(REST_API + 'hinzufuegen/0', JSON.stringify(aktuell));
//     else
//       request = this.http.put(REST_API + 'bearbeiten/' + this.aktuell.id, JSON.stringify(aktuell));
//
//     request
//        // Um mehrfachaufrufe zu verhindern
//       .subscribe(
//       data => {
//         this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
//         if(reloadData) {
//           this.getAntworten();
//         }
//         else {
//           this.ladedaten = false;
//           this.closeOpenDialog();
//         }
//         this.openSnackBar(snacknachricht);
//         this._logger.log(PATH_FILE + ' - speichern End');
//       },
//       err => {
//         this.handleError(err, "Fehler beim speichern (" + (this.neu ? "neu" : "bearbeiten") + ") der Antwort")
//       });
//   } // speichern
//
//
//   constructor(
//     private route: ActivatedRoute,
//     public locale: LocaleService,
//     public translation: TranslationService,
//     public authService: AuthService,
//     private breadcrumbService: BreadcrumbService,
//     public sessService: SessionService,
//     private authHttp: AuthHttp,
//     public title: Title,
//     public snackBar: MatSnackBar,
//     public _logger: LoggerService) {
//       super(locale, translation, _logger, PATH_FILE);
//     // Set document title.
//     this.title.setTitle(this.getTitle());
//
//     this.breadcrumbService.addFriendlyNameForRoute('/protected/verwaltungfragebogen/verwaltungfragen/verwaltungantworten', this.translation.translate('antwort.liste'));
//     this.breadcrumbService.addFriendlyNameForRoute('/protected/verwaltungfragebogen/verwaltungfragen', this.translation.translate('frage.liste')+'('+this.frage.fragestellung+')');
//     this.breadcrumbService.addFriendlyNameForRoute('/protected/verwaltungfragebogen', this.translation.translate('fragebogen.liste')+'('+this.fragebogen.name+')');
//     this.getAntworten();
//   }
//
//   speichernAend(antwort: Antwort) {
//     this._logger.log(PATH_FILE + ' - speichernAend BEGIN');
//     this._logger.log(PATH_FILE + ' - speichernAend - kategorie: ', antwort);
//
//     let snacknachricht = this.translation.translate((this.neu ? 'allgemein.daten.hinzugefügt' : 'allgemein.daten.geändert'), { typ: this.translation.translate('antwort.title') });
//     this.speichern(antwort, snacknachricht);
//   } // speichernAend
//
//   loeschen(antwort: Antwort) {
//     this.dialogrunningajaxcall = this.isDialogOpen() ? true : false;
//     this._logger.log(PATH_FILE + ' - loeschen BEGIN');
//     this._logger.debug(PATH_FILE + ' - loeschen - Frage: ', JSON.stringify(antwort));
//
//     this._logger.log(PATH_FILE + ' - loeschen - http: ' + REST_API + 'loeschen/' + antwort.id);
//     this.http
//       .delete(REST_API + 'loeschen/' + antwort.id)
//        // Um mehrfachaufrufe zu verhindern
//       .subscribe(
//       data => {
//         this.authService.storeNewToken(data); // Das token mit dem vom Server neu gelieferten erneuern
//         this._logger.log(PATH_FILE + ' - got answer data: ', data);
//         this.getAntworten();
//         this._logger.log(PATH_FILE + ' - loeschen End');
//       },
//       err => ErrorHelper.handleError(err,"Fehler beim löschen der Antwort",this._logger, this.translation)
//       );
//   } // loeschen
//
//
//    zeigeHinzufuegenMaske() {
// //    this.inserteditForm.reset();
//     this.neu = true;
//     this.aktuell = new Antwort();
//     this.aktuell.frageId = this.frage.id;
//     this._logger.log(PATH_FILE + ' - zeigeHinzufuegenMaske this.aktuell:', this.aktuell);
//     this.doOpenDialog(this.insertedit,{ disableClose: true });
//   } // zeigeHinzufuegenMaske
//
//    zeigeBearbeitenMaske(frage: Frage) {
//     this._logger.log(PATH_FILE + ' - zeigeBearbeitenMaske Eintrag:', frage);
//     this.neu = false;
//     this.aktuell = JSON.parse(JSON.stringify(frage));
//     this._logger.log(PATH_FILE + ' - zeigeBearbeitenMaske this.aktuell:', this.aktuell);
//     this.doOpenDialog(this.insertedit,{ disableClose: true });
//   } // zeigeBearbeitenMaske
//
//   zeigeLoeschenMaske(fragebogen: Fragebogen) {
//     this.aktuell = JSON.parse(JSON.stringify(fragebogen));
//     this.doOpenDialog(this.delete,{ disableClose: true });
//   } // zeigeLoeschenMaske
//
//   openSnackBar(message: string, action: string = null) {
//     this.snackBar.open(message, action, {duration: 5 * 1000});
//   }
//
//   leereHelper(resetForms: boolean = true) {
//     this._logger.log(PATH_FILE + ' - leereHelper BEGIN');
//     this.aktuell = null;
//     if(this.isDialogOpen())
//       this.fehlerDialog = null
//     if(this.isSecondDialogOpen())
//       this.fehlerSecondDialog = null
//     this.neu = false;
//     this.dialogrunningajaxcall = false;
//     if(resetForms) {
//     }
//   }
//
//    public handleError (error: Response | any, prefix: string = "handleError") {
//     this._logger.log(PATH_FILE + ' - handleError - ' + prefix + ': ', error);
//
//     this.dialogrunningajaxcall = false;
//
//     let fehler = new Kernantwort();
//     if (error instanceof Response) {
//       try {
//         fehler = error.json();
//         if(error.status==0 && !error.ok && error.type==ResponseType.Error && error.statusText.length==0) {
//           fehler.httpstatus = new Httpstatus();
//           fehler.httpstatus.name = 'vermutlich 503er Service Temporarily Unavailable';
//           fehler.httpstatus.number = 500;
//         }
//       } catch (e) {
// //        this.fehler.message = error.toString();
//         fehler.messagehtml = this.translation.translate('allgemein.fehler');
// //        this.fehler.messagehtml = error.text();
//         this._logger.error(PATH_FILE + ' - ERROR ' + error.status + ': ' + prefix + ' (' + error.statusText + ' (' + error.status + ')' + '): ', error.text());
//       }
//     } else {
//       fehler = new Kernantwort();
//       fehler.message = error.message ? error.message : error.toString();
//     }
//
//     if(!fehler.messagehtml)
//       fehler.messagehtml = fehler.message;
//
//     if(fehler && fehler.httpstatus && fehler.httpstatus.number == 500) {
//       this._logger.error(PATH_FILE + ' - ' + prefix + ':' + fehler.messagehtml);
//       fehler.messagehtml = this.translation.translate('allgemein.fehler');
//       this._logger.error(PATH_FILE + ' - ERROR 500: ' + prefix + ' (' + fehler.httpstatus.name + ' (' + fehler.httpstatus.number + ')' + '): ', fehler);
//     } else {
//       this._logger.info(PATH_FILE + ' - ' + prefix + ': ', fehler);
//     }
//
//     // Nach dem der Fehler fertig erstellt wurde die entsprechende Fehler variable setzten
//     this.setzeFehler(fehler);
//
//     // Das token mit dem vom Server neu gelieferten erneuern:
//     this.authService.storeNewToken(error);
//
//     return Observable.throw(fehler.message);
//   }
//
// }
